import React, { useEffect, useRef, useState } from "react";
import update from "immutability-helper";

const randomId = () => Math.round(Math.random() * 10000000);

import {
  project_upload_attachment_path
} from '~/routes';

const Routes = {
  project_upload_attachment_path: project_upload_attachment_path,
};

const FileUpload = ({
  uploadPath,
  uploadParams,
  downloadPathCallback,
  defaultFiles,
  inputNamespace,
  onResize = () => {},
  onChange = () => {},
}) => {
  const [files, setFiles] = useState(defaultFiles || []);
  const dz = useRef();
  const zoneRef = useRef();
  const id = React.useMemo(() => `dropzone_${randomId()}`, []);
  const uploadId = React.useMemo(() => `upload_${randomId()}`, []);
  const uploadPathFn = typeof uploadPath == "function" ? uploadPath : Routes[uploadPath];
  const uploadUrl = uploadPathFn(Object.assign(uploadParams, { upload_id: uploadId }));
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    dz.current = new Dropzone(`#${id}`, {
      url: uploadUrl,
      headers: {
        "X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr("content"),
      },
      dictDefaultMessage: I18n.t("attachment_drop_multiple_instruction"),
      addRemoveLinks: true,
      dictRemoveFile: "",
    });

    setMounted(true);
  }, []);

  const processFile = React.useCallback(
    (file) => {
      dz.current.options.url = uploadPathFn(
        Object.assign(uploadParams, { upload_id: uploadId, uuid: file?.upload?.uuid })
      );
    },
    [uploadId]
  );

  const complete = React.useCallback(
    (file) => {
      dz.current.removeFile(file);
      // Ignore canceled files
      // Maybe we could show error message if status is something other than 'success' or 'canceled'
      if (file.status == "success") {
        setFiles(
          update(files, {
            $push: [
              {
                name: file.name,
                content_type: file.type,
                upload_id: uploadId,
                uuid: file.upload.uuid,
              },
            ],
          })
        );
      }
    },
    [files, uploadId]
  );

  useEffect(() => {
    dz.current.off("processing").on("processing", processFile);
  }, [processFile]);

  useEffect(() => {
    dz.current.off("complete").on("complete", complete);
  }, [complete]);

  const deleteFile = (e, idx) => {
    e.preventDefault();
    setFiles(update(files, { [idx]: { $merge: { deleted: true } } }));
  };

  const handleResize = () => {
    const zone = jQuery(zoneRef.current);
    if (zone.length > 0) {
      onResize(zone.outerHeight());
    }
  };

  useEffect(() => {
    handleResize();
  }, [files, mounted]);

  useEffect(() => {
    if (mounted) {
      onChange(files);
    }
  }, [files]);

  const inputName = inputNamespace ? `${inputNamespace}[files]` : `files`;

  return (
    <>
      <div id={id} ref={zoneRef} className="dropzone file-upload-area">
        {mounted &&
          files.map((f, i) =>
            f.deleted ? null : (
              <div key={`${f.name}-${i}`} className="dz-preview">
                <div className="dz-details">
                  {downloadPathCallback && !f.upload_id ? (
                    <a
                      href={(typeof downloadPathCallback == "string"
                        ? (0, eval)(downloadPathCallback)
                        : downloadPathCallback)(f)}
                      data-av={true}
                      data-av-content-type={f.content_type}
                      data-av-title={f.name}
                    >
                      {f.name}
                    </a>
                  ) : (
                    <>
                      <span className="dz-filename">{f.name}</span>
                      <input
                        type="hidden"
                        name={`${inputName}[${f.upload_id}][new][]`}
                        value={f.uuid}
                      />
                    </>
                  )}
                </div>
                {f.locked ? null : (
                  <a href="#" className="dz-remove delete-file" onClick={(e) => deleteFile(e, i)} />
                )}
              </div>
            )
          )}
      </div>
      {files
        .filter((f) => f.deleted && !f.upload_id)
        .map((f, i) => (
          <input
            key={`${f.id || f.filesystem_name}-${i}`}
            type="hidden"
            name={`${inputName}[${uploadId}][deleted][]`}
            value={f.id || f.filesystem_name}
          />
        ))}
    </>
  );
};

export default FileUpload;
